import React, { useEffect, useState } from "react";
import { useAdminState } from "../contexts/AdminContext";
import * as API from "../api/request";
import Swal from "sweetalert2";
import _ from "lodash";
import { useOpenState } from "../contexts/OpenContext";

const Article = () => {
  const { admin, setAdmin } = useAdminState();
  const { state } = useOpenState();
  const [temp_dept, setTemp_dept] = useState(0);
  const [temp_tn, setTemp_tn] = useState("");

  useEffect(() => {
    if (state?.userGroupList?.includes(362)) {
      API.departments()
        .then((res) => {
          let result = [];
          _.map(res, (el) => {
            result.push({
              name_mon: el.name_mon.replace(/"/g, ""),
              department_code: el.department_code,
            });
          });
          setAdmin({
            type: "ARTICLE_DEPARTMENT_LIST",
            data: _.orderBy(
              result,
              [(el) => el.name_mon.toLowerCase()],
              ["asc"]
            ),
          });
        })
        .catch(() => {
          Swal.fire(
            "Анхаар",
            "Бүтцийн нэгжийн жагсаалт татаж чадсангүй!",
            "warning"
          );
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    API.getArticle()
      .then((res) => {
        setAdmin({ type: "ARTICLE_LIST", data: res });
      })
      .catch(() => {
        Swal.fire("Анхаар", "Жагсаалт татаж чадсангүй!", "warning");
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [admin.article.refresh]);

  const save = () => {
    let validation = "";
    admin.article.category_id || (validation += "Бүлэг сонгоно уу.<br/>");
    admin.article.article_name || (validation += "Гарчиг бичнэ үү.<br/>");
    if (validation !== "") {
      Swal.fire({
        icon: "warning",
        html: validation,
      });
    } else {
      var json = {
        category_id: admin.article.category_id,
        article_name: admin.article.article_name,
      };
      if (admin.article.users.length > 0) {
        json = {
          ...json,
          users: admin.article.users,
        };
      }
      if (admin.article.departments.length > 0) {
        json = {
          ...json,
          departments: admin.article.departments,
        };
      }

      API.postputArticle(admin.article.id, json)
        .then(() => {
          setAdmin({ type: "ARTICLE_REFRESH" });
          Swal.fire("Амжилттай", "Амжилттай бүртгэгдлээ.", "success");
        })
        .catch(() => {
          Swal.fire(
            "Анхаар",
            "Бүртгэж чадсангүй дахин оролдоно уу!",
            "warning"
          );
        });
    }
  };

  const trash = (id) => {
    Swal.fire({
      title: "Та устгахдаа итгэлтэй байна уу?",
      text: "Сэргэх боломжгүйг анхаарна уу!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Тийм",
      cancelButtonText: "Үгүй",
    }).then((result) => {
      if (result.isConfirmed) {
        API.deleteArticle(id)
          .then(() => {
            setAdmin({ type: "ARTICLE_REFRESH" });
            Swal.fire("Амжилттай", "Амжилттай устгалаа.", "success");
          })
          .catch(() => {
            Swal.fire(
              "Анхаар",
              "Устгаж чадсангүй дахин оролдоно уу!",
              "warning"
            );
          });
      }
    });
  };

  return (
    <div className={admin.article.modal ? "block" : "hidden"}>
      <div className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 w-full h-modal h-full bg-black opacity-30 z-[61]"></div>
      <div
        className="fixed top-1/2 left-1/2 w-full h-auto z-[62]"
        style={{ transform: "translate(-50%, -50%)" }}
      >
        <div className="relative bg-white shadow">
          <div className="flex justify-between items-center px-4 py-2 border-b">
            <div className="font-semibold text-gray-900">Гарчиг</div>
            <button
              type="button"
              className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
              data-modal-toggle="defaultModal"
              onClick={() => setAdmin({ type: "ARTICLE_MODAL", data: false })}
            >
              <svg
                aria-hidden="true"
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
          <div className="p-4 h-[calc(100vh-50px)]">
            {/* body */}
            <div className="relative max-h-[calc(100vh-100px)] overflow-auto">
              <div className="flex items-start justify-center gap-2">
                <select
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:border-[#A3C050] block w-full p-2 focus:outline-none flex-1"
                  value={admin.article.category_id}
                  onChange={(e) => {
                    setAdmin({
                      type: "ARTICLE_FORM_CHANGE",
                      data: {
                        category_id: e.target.value,
                      },
                    });
                  }}
                >
                  <option value={0}>Бүлэг сонгох</option>
                  {admin.category.list.map((el) => {
                    return (
                      <option value={el.id} key={el.id}>
                        {el.category_short}
                      </option>
                    );
                  })}
                </select>
                <textarea
                  rows="4"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:border-[#A3C050] block w-full p-2 focus:outline-none flex-1"
                  placeholder="Гарчиг бичнэ үү"
                  maxLength={500}
                  value={admin.article.article_name}
                  onChange={(e) => {
                    setAdmin({
                      type: "ARTICLE_FORM_CHANGE",
                      data: {
                        article_name: e.target.value,
                      },
                    });
                  }}
                />
                {/* <input
                  type="text"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:border-[#A3C050] block w-full p-2 focus:outline-none flex-1"
                  maxLength={500}
                  placeholder="Бүлгийн нэр бичнэ үү"
                  value={admin.article.article_name}
                  onChange={(e) => {
                    setAdmin({
                      type: "ARTICLE_FORM_CHANGE",
                      data: {
                        article_name: e.target.value,
                      },
                    });
                  }}
                /> */}
              </div>
              <div className="flex items-center justify-center gap-2 mt-2">
                <div className="flex-1">
                  <span className="text-xs text-red-500">
                    ( Мэдээлэл оруулах ажилтнууд сонгох )
                  </span>
                  <input
                    type="text"
                    minLength={0}
                    maxLength={5}
                    placeholder="БД оруулаад Enter дарна уу."
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:border-[#A3C050] block w-full p-2 focus:outline-none"
                    value={temp_tn}
                    onChange={(e) => {
                      const re = /^[0-9\b]+$/;
                      if (e.target.value === "" || re.test(e.target.value)) {
                        setTemp_tn(e.target.value);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (
                        (e.key === "Enter" || e.key === "Tab") &&
                        e.target.value !== ""
                      ) {
                        API.searchWorker(e.target.value)
                          .then((res) => {
                            var oldusers = admin.article.users;
                            oldusers.push({
                              tn: res.tn,
                              shortname:
                                res.surname.split("")[0] + "." + res.firstname,
                              position: res.position_namemn,
                            });
                            setAdmin({
                              type: "ARTICLE_USERS",
                              data: oldusers,
                            });
                            setTemp_tn("");
                          })
                          .catch(() => {
                            Swal.fire(
                              "Анхаар",
                              e.target.value +
                                " - Бүртгэлийн дугаартай ажилтан олдсонгүй.",
                              "warning"
                            );
                          });
                      }
                    }}
                  />
                </div>
                <div className="flex-1">
                  <span className="text-xs text-red-500">
                    ( Мэдээлэл хариуцах бүтцийн нэгжүүдийг сонгох )
                  </span>
                  <select
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:border-[#A3C050] block w-full p-2 focus:outline-none"
                    value={temp_dept}
                    onChange={(e) => {
                      if (e.target.value !== "0") {
                        var check = admin.article.departments.find(
                          (el) =>
                            el.department_code === e.target.value.split("&&")[0]
                        );
                        if (!check) {
                          var olddepartment = admin.article.departments;
                          olddepartment.push({
                            department_code: e.target.value.split("&&")[0],
                            department_name: e.target.value.split("&&")[1],
                          });
                          setAdmin({
                            type: "ARTICLE_DEPARTMENT",
                            data: olddepartment,
                          });
                          setTemp_dept(0);
                        } else {
                          Swal.fire(
                            "Анхаар",
                            "Энэ бүтцийн нэгж сонгогдсон байна!",
                            "warning"
                          );
                        }
                      }
                    }}
                  >
                    <option value={0}>Бүтцийн нэгж сонгох</option>
                    {admin.article.department_list.map((el, index) => {
                      return (
                        <option
                          value={el.department_code + "&&" + el.name_mon}
                          key={index}
                        >
                          {el.name_mon}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="flex gap-2 max-h-[150px] overflow-auto scrollbar">
                <div className="flex-1">
                  <table className="min-w-full">
                    <thead className="border-b">
                      <tr className="bg-gray-100">
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-2 py-2 text-center"
                        >
                          БД
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-2 py-2 text-left"
                        >
                          Нэр
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-2 py-2 text-center"
                        >
                          #
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {admin.article.users.length > 0 ? (
                        admin.article.users.map((el, index) => {
                          return (
                            <tr className="border-b" key={index}>
                              <td className="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-900 text-center">
                                {el.tn}
                              </td>
                              <td className="text-sm text-gray-900 font-light px-2 py-2">
                                {el.shortname}
                              </td>
                              <td className="text-sm text-gray-900 font-light px-2 py-2 whitespace-nowrap text-center">
                                <i
                                  className="fa fa-trash text-red-700 cursor-pointer"
                                  onClick={() => {
                                    setAdmin({
                                      type: "ARTICLE_USERS",
                                      data: admin.article.users.filter(
                                        (item) => item.tn !== el.tn
                                      ),
                                    });
                                  }}
                                />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr className="border-b">
                          <td
                            className="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-900 text-center"
                            colSpan={3}
                          >
                            Хоосон байна
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="flex-1">
                  <table className="min-w-full">
                    <thead className="border-b">
                      <tr className="bg-gray-100">
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-2 py-2 text-center"
                        >
                          Код
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-2 py-2 text-left"
                        >
                          Нэр
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-2 py-2 text-center"
                        >
                          #
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {admin.article.departments.length > 0 ? (
                        admin.article.departments.map((el, index) => {
                          return (
                            <tr className="border-b" key={index}>
                              <td className="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-900 text-center">
                                {el.department_code}
                              </td>
                              <td className="text-sm text-gray-900 font-light px-2 py-2">
                                {el.department_name}
                              </td>
                              <td className="text-sm text-gray-900 font-light px-2 py-2 whitespace-nowrap text-center">
                                <i
                                  className="fa fa-trash text-red-700 cursor-pointer"
                                  onClick={() => {
                                    setAdmin({
                                      type: "ARTICLE_DEPARTMENT",
                                      data: admin.article.departments.filter(
                                        (item) =>
                                          item.department_code !==
                                          el.department_code
                                      ),
                                    });
                                  }}
                                />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr className="border-b">
                          <td
                            className="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-900 text-center"
                            colSpan={3}
                          >
                            Хоосон байна
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="flex items-center justify-center my-2">
                <button
                  className="py-1 px-2 flex items-center justify-center font-semibold text-[#A3C050] border-2 border-[#A3C050] rounded-md hover:bg-[#A3C050] hover:text-white focus:outline-none duration-300"
                  onClick={() => save()}
                >
                  Хадгалах
                </button>
              </div>

              <div className="h-[calc(100vh-480px)] overflow-auto scrollbar">
                <table className="min-w-full">
                  <thead className="border-b">
                    <tr className="bg-gray-100">
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 text-center"
                      >
                        №
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 text-left"
                      >
                        Бүлэг
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 text-left"
                      >
                        Гарчиг
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 text-left"
                      >
                        Ажилтан
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 text-left"
                      >
                        Бүтцийн нэгж
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 text-center"
                      >
                        #
                      </th>
                    </tr>
                  </thead>
                  <tbody className="h-[50px] max-h-[50px] overflow-auto">
                    {admin.article.list.length > 0 ? (
                      admin.article.list.map((el, index) => {
                        var category = admin.category.list.find(
                          (item) => item.id === el.category_id
                        );
                        return (
                          <tr className="border-b" key={el.id}>
                            <td className="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-900 text-center">
                              {index + 1}
                            </td>
                            <td className="text-sm text-gray-900 font-light px-2 py-2">
                              {category?.category_short}
                            </td>
                            <td className="text-sm text-gray-900 font-light px-2 py-2">
                              {el.article_name}
                            </td>
                            <td className="text-sm text-gray-900 font-light px-2 py-2 overflow-hidden">
                              {el.users.length > 0 &&
                                el.users.map((user) => {
                                  return user.shortname + " ";
                                })}
                            </td>
                            <td className="text-sm text-gray-900 font-light px-2 py-2 overflow-hidden">
                              {el.departments.length > 0 &&
                                el.departments.map((dept) => {
                                  return dept.department_name + " ";
                                })}
                            </td>
                            <td className="text-sm text-gray-900 font-light px-2 py-2 whitespace-nowrap text-center">
                              <i
                                className="fa fa-edit text-blue-700 cursor-pointer mr-2"
                                onClick={() => {
                                  setAdmin({
                                    type: "ARTICLE_FORM_CHANGE",
                                    data: {
                                      id: el.id,
                                      category_id: el.category_id,
                                      article_name: el.article_name,
                                      users: el.users,
                                      departments: el.departments,
                                    },
                                  });
                                }}
                              />
                              <i
                                className="fa fa-trash text-red-700 cursor-pointer"
                                onClick={() => trash(el.id)}
                              />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="border-b">
                        <td
                          className="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-900 text-center"
                          colSpan={3}
                        >
                          Хоосон байна
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {/* body */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Article);
